export enum PdpFeatureImpactType {
  Off = 0,
  HidePersistentBanner = 1,
  HideBreadcrumbs = 2,
  HidePromoBanner = 3,
  HideInStockMessage = 4,
  HideProductSpecifications = 5,
  HideProductRank = 6,
  HideFrequentlyPurchasedTogether = 7,
  HideCustomerAlsoViewed = 8,
  HideAuthenticBanner = 9,
  HideWriteReviewBanner = 10,
  HideAiGenReviewTagsAndBanner = 11,
  HideTopReviews = 12,
}
